import { msgTypes } from "constants/msgTypes";
import { Validation } from "constants/Validation";
import * as Yup from "yup";

export const FinancialProtectionMessageSchema = Yup.object({
    financialProtectionMessageId: Yup.string(),
    financialProtectionMessage: Yup.string().required(Validation.required.message.replaceAll("^","Message"))
                    .matches(Validation.plaintext.regex , Validation.plaintext.message),
    status: Yup.boolean()
    
})
